import { render, staticRenderFns } from "./newBottom.vue?vue&type=template&id=1bb8e00a&scoped=true"
import script from "./newBottom.vue?vue&type=script&lang=js"
export * from "./newBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8e00a",
  null
  
)

export default component.exports